// src/index.js  (or main.jsx if you’re using Vite)
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { CameraProvider } from "./CameraContext";   // ✅ correct relative path
import "./App.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <CameraProvider>     {/*  ← PROVIDER WRAPS EVERYTHING */}
      <App />
    </CameraProvider>
  </BrowserRouter>
);
